import { postRequest } from 'utils/httpServices';

class reportsAPI {
  static list = (queryData = {}, config = {}) => {
    return postRequest(`v1/report/get-transaction-reports`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static merchant_list = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-referred-merchants-basic-details`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static generate = (queryData = {}, config = {}) => {
    return postRequest(`v1/report/generate-transaction-report`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static downloadable = (queryData = {}, config = {}) => {
    return postRequest(`v1/report/download-transaction-report`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static payoutList = (queryData = {}, config = {}) => {
    return postRequest(`v1/payout_report/list-partner-pending-payouts`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static bulkInvoiceSummary = (queryData = {}, config = {}) => {
    return postRequest(`v1/payout_report/bulk-payout-summary`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static bulkInvoiceSubmit = (queryData = {}, config = {}) => {
    return postRequest(`v1/payout_report/bulk-invoice-upload`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static bulkInvoiceList = (queryData = {}, config = {}) => {
    return postRequest(`v1/payout_report/list-bulk-pending-invoice`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static payoutRaiseDispute = (queryData = {}, config = {}) => {
    return postRequest(`v1/payout_report/raise-partner-payout-dispute`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static payoutAcceptInvoice = (queryData = {}, config = {}) => {
    return postRequest(`v1/payout_report/accept-partner-payout-report`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static invoiceList = (queryData = {}, config = {}) => {
    return postRequest(`v1/payout_report/fetch-settled-partner-payouts`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static downloadReport = (queryData = {}, config = {}) => {
    return postRequest(`v1/report/generate-signed-url`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static customReportsList = (queryData = {}, config = {}) => {
    return postRequest(`v1/report/get-custom-reports`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static generateCustomReports = (queryData = {}, config = {}) => {
    return postRequest(`v1/report/generate-custom-report`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };
}

export default reportsAPI;
